// eslint-disable-next-line
import ResetPassword from './ResetPassword';

export default ResetPassword;
